// extracted by css-extract-rspack-plugin
export default {"Container":"BranchActionMenu-module__Container__e3sub","ActionButtonGroup":"BranchActionMenu-module__ActionButtonGroup__AGrdf"};